import { render, staticRenderFns } from "./calculadora.vue?vue&type=template&id=7236ebd0&scoped=true"
import script from "./calculadora.vue?vue&type=script&lang=ts"
export * from "./calculadora.vue?vue&type=script&lang=ts"
import style0 from "./calculadora.vue?vue&type=style&index=0&id=7236ebd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7236ebd0",
  null
  
)

export default component.exports